
import { makeStyles } from '@mui/styles';

const styles = (theme) => ({

    container: () => {
      return  {
          display: 'flex',
          height: '100vh',
          width: '100%',

          flexDirection: 'column !important',
          justifyContent: 'center',
          alignItems: 'center',
          position: 'absolute',
          top: 0,
          left: 0,
          overflow: 'scroll',
      };
    },

    body: () => {
      return  {
        display: 'flex',
        width: 'calc(100% - 64px)',
        flexDirection: 'column !important',
        justifyContent: 'center',
        alignItems: 'center',
      };
    },

    subtitle: () => {
      return  {
        display: 'flex',
        width: '100%',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: '20px',
      };
    },

    bodyMessages: () => {
      return  {
        display: 'flex',
        flexDirection: 'column !important',
        fontSize: '14px',
        width: '100%',
        fontWeight: 'regular',
        justifyContent: 'center',
        alignItems: 'center',
        margin: '24px 0px',
        textAlign: 'center',
      };
    },
 
    buttonPanel: () => {
      return  {
        display: 'flex',
        width: '100%',
        justifyContent: 'center',
        alignItems: 'center',
      };
    },
    
    help: {
      display: 'flex',
      flexDirection: 'row',
      width: 'calc(100% - 64px)',
      justifyContent: 'center',
    },

    tryagain: {
      marginTop: '24px',
      marginBottom: '24px',
      display: 'flex',
      flexDirection: 'row',
      width: 'calc(100% - 64px)',
      justifyContent: 'center',
    },

    spinnerBox: {
      display: 'flex',
      width: '70%',
    },

   
});

export default styles;
export const useStyles = makeStyles(styles);
